import * as React from 'react';
import { SVGProps } from 'react';

export const StarFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={14} fill="none" {...props}>
    <path
      fill="url(#a)"
      d="M7.092.564a1.012 1.012 0 0 1 1.815 0l1.71 3.465 3.823.555a1.012 1.012 0 0 1 .562 1.726l-2.768 2.698.654 3.808a1.012 1.012 0 0 1-1.469 1.065L8 12.085l-3.42 1.798a1.011 1.011 0 0 1-1.467-1.067l.652-3.808L.998 6.31a1.012 1.012 0 0 1 .561-1.726l3.822-.555L7.092.564Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={15.306}
        x2={0.27}
        y1={14.313}
        y2={0.134}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6F47" />
        <stop offset={1} stopColor="#FFCD0F" />
      </linearGradient>
    </defs>
  </svg>
);
export default StarFilled;
